import { Box } from '@mui/material';
import React, { ChangeEvent, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import FlexRow from 'components/shared/FlexRow';
import Chip from '@mui/material/Chip';
import { MdAttachFile } from '../../../icons';
import { useLazyQuery, useMutation } from '@apollo/client';
import {
  ADD_FILE_TO_PROFILE,
  DELETE_FILE_FROM_PROFILE,
} from '../../../../api/mutations/employeeFIle';
import { GET_ALL_FILES_FOR_PROFILE } from '../../../../api/queries/employeeFiles';
import { Spinner } from '../../../shared';
import { get } from 'lodash';

const RenderFiles = () => {
  // chose to have this manage state as well because of refetch capabilities and speed to deployment, fight me.

  const [
    fetchFiles,
    {
      loading: fetchFilesLoading,
      refetch: refetchFiles,
      data: filesResponse,
    },
  ] = useLazyQuery(GET_ALL_FILES_FOR_PROFILE, {
    fetchPolicy: 'cache-and-network',
  });
  const [deleteFile, { loading: deleteFileLoading }] =
    useMutation(DELETE_FILE_FROM_PROFILE, {
      fetchPolicy: 'no-cache',
    });
  const [addFile, { loading: addFileLoading }] = useMutation(
    ADD_FILE_TO_PROFILE,
    {
      fetchPolicy: 'no-cache',
    },
  );

  useEffect(() => {
    fetchFiles();
  }, []);

  const handleDeleteFile = async (fileId: number) => {
    await deleteFile({
      variables: {
        fileId,
      },
    });
    await refetchFiles();
  };

  const handleAddFile = async (
    e: ChangeEvent<HTMLInputElement>,
  ) => {
    if (!e.target.files || e.target.files.length === 0) {
      console.warn('No file selected.');
      return;
    }

    const file = e.target.files[0];

    try {
      await addFile({
        variables: {
          file,
        },
      });

      await refetchFiles();
    } catch (error) {
      console.error('File upload error:', error);
    }
  };

  // delete file
  // download file?

  const files = get(filesResponse, 'getAllFilesForProfile', []);

  return (
    <Box className={'sectionContainer chipContainer'}>
      <Typography variant={'h2'}>
        Files associated with your profile
      </Typography>
      <FlexRow style={{ marginTop: '1rem' }}>
        {fetchFilesLoading && <Spinner />}
        {!files && (
          <Typography variant={'body1'}>No Files</Typography>
        )}
        {files &&
          files.map((file) => (
            <Chip
              label={file.name}
              key={file.id}
              variant={'filled'}
              color={'primary'}
              disabled={deleteFileLoading}
              onClick={() => {
                const link = document.createElement('a');
                link.href = file.imageUrl;
                link.download = file.name;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
              onDelete={() => handleDeleteFile(file.id)}
            />
          ))}
        <Box>
          <input
            id="file-upload"
            style={{ display: 'none' }}
            type="file"
            onChange={handleAddFile}
            accept=".doc,.docx,.txt,.pdf,.jpeg,.jpg,.gif,.png"
          />
          <label htmlFor="file-upload">
            <Chip
              label={'Add File'}
              variant={'filled'}
              color={'success'}
              disabled={addFileLoading}
              deleteIcon={<MdAttachFile />}
            />
          </label>
        </Box>
      </FlexRow>
    </Box>
  );
};

export default RenderFiles;
